/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Drawer,
  Box,
  Typography,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  Button,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  Paper,
  Stack,
  IconButton,
  Collapse,
  Card,
  CardContent,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { fetcher } from 'src/utils/axios';
import Iconify from 'src/components/iconify';

const reconstructFormulaString = (formula) => {
  if (!formula || !formula.operands || !formula.operation || !Array.isArray(formula.operands)) return '';

  const operationMap = {
    add: '+',
    subtract: '-',
    multiply: '*',
    divide: '/',
  };
  const operator = operationMap[formula.operation] || formula.operation;

  const processOperand = (operand) => {
    if (typeof operand === 'string') {
      return operand;
    } else if (operand && operand.operation && operand.operands) {
      return `(${reconstructFormulaString(operand)})`;
    }
    return '';
  };

  const processedOperands = formula.operands
    .slice()
    .reverse()
    .map(processOperand)
    .filter(op => op !== '');

  return processedOperands.join(` ${operator} `);
};

const NodePropertiesDrawer3rdStep = ({
  open,
  onClose,
  selectedNode,
  loadingNodeData,
  editNodeName,
  setEditNodeName,
  editRawMaterialInputs,
  utilityOptions,
  handleUpdateNode,
  setselectedVariantsfromparent,
  seteditoutputids,
  setutitilityfromdrawer,
  isEditing,
  clickednodes,
  setNodeColor,
  // setinventoryPayload
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [fetchedNodeData, setFetchedNodeData] = useState(null);
  const [fetchingNodeData, setFetchingNodeData] = useState(false);
  const [productVariantMap, setProductVariantMap] = useState({});
  const [loadingVariants, setLoadingVariants] = useState({});
  const [variantOptions, setVariantOptions] = useState({});
  const [editutitilty, seteditutitilty] = useState([]);
  const [hasrawmaterial, sethasrawmaterial] = useState(false);
  const [shownNotifications, setShownNotifications] = useState([]);
  const [nodeVariants, setNodeVariants] = useState({});
  const [selectedVariants, setSelectedVariants] = useState({});
  const [variantQuantities, setVariantQuantities] = useState({});
  const [totalVariantQuantities, setTotalVariantQuantities] = useState({});
  const [showNodeDetails, setShowNodeDetails] = useState(false);
  const [variantAggregates, setVariantAggregates] = useState({});
  const [variantInventory, setVariantInventory] = useState({});
  const [selectedInventoryItems, setSelectedInventoryItems] = useState({});
  const [aggregableValues, setaggregableValues] = useState();

  // FIXED: Access data from selectedNode.data instead of getOptions()
  const currentNodeId = selectedNode?.data?.backendId;
  const currentNodeName = selectedNode?.data?.label;

  // Debug log for state changes
  useEffect(() => {
    console.log('🔍 [nodeVariants UPDATED]', nodeVariants);
    console.log('🔍 [variantAggregates UPDATED]', variantAggregates);
    console.log('🔍 [variantInventory UPDATED]', variantInventory);
    console.log('🔍 [selectedInventoryItems UPDATED]', selectedInventoryItems);
    console.log('🔍 [totalVariantQuantities UPDATED]', totalVariantQuantities);
    console.log('🔍 [currentNodeId]', currentNodeId);
    console.log('🔍 [selectedVariants]', selectedVariants);
  }, [nodeVariants, variantAggregates, variantInventory, selectedInventoryItems, totalVariantQuantities, currentNodeId, selectedVariants]);


  useEffect(() => {
    console.log('🚀 [useEffect] Starting fetchNodeData for node:', currentNodeId);
    
    const fetchNodeData = async () => {
      // FIXED: Access backendId from selectedNode.data
      if (!selectedNode || !selectedNode.data?.backendId) {
        console.log('❌ [fetchNodeData] No selected node or backendId');
        return;
      }
      
      setFetchingNodeData(true);
      try {
        const id = selectedNode.data.backendId; // FIXED: Use selectedNode.data.backendId
        console.log('📡 [fetchNodeData] Fetching data for node ID:', id);
        
        const res = await fetcher([`/new/workflow-app/node/${id}/`]);
        console.log('✅ [fetchNodeData] API Response:', res);
        
        setFetchedNodeData(res);
        seteditoutputids(res?.output_foreign);

        // Extract product IDs and variant data
        const productIds = res?.input_foreign?.[0]?.value?.product_ids || [];
        const allVariantIds = res?.input_foreign?.[0]?.value?.product_variant_ids || [];
        const productVariantData = res?.input_foreign?.[0]?.product_variant_data || [];
        const productData = res?.input_foreign?.[0]?.product_data || [];
        setselectedVariantsfromparent([productVariantData]);
        console.log('📦 [fetchNodeData] Product IDs:', productIds);
        console.log('📦 [fetchNodeData] All Variant IDs:', allVariantIds);
        console.log('📦 [fetchNodeData] Product Variant Data:', productVariantData);
        console.log('📦 [fetchNodeData] Product Data:', productData);

        // Create a mapping of which variants belong to which products
        const variantMap = {};
        
        productIds.forEach(productId => {
          const product = productData.find(p => p.id === productId);
          console.log(`🔍 [fetchNodeData] Processing product ${productId}:`, product);
          
          if (product) {
            const productVariants = productVariantData.filter(variant => {
              const variantBelongsToProduct = variant.name.includes(product.name);
              console.log(`🔍 [fetchNodeData] Variant ${variant.id} "${variant.name}" belongs to product "${product.name}":`, variantBelongsToProduct);
              return variantBelongsToProduct;
            });
            
            variantMap[productId] = productVariants.map(v => v.id);
            console.log(`📋 [fetchNodeData] Product ${productId} variants:`, variantMap[productId]);
          } else {
            variantMap[productId] = [];
            console.log(`❌ [fetchNodeData] No product data found for ID: ${productId}`);
          }
        });
        
        console.log('🗺️ [fetchNodeData] Final Product Variant Map:', variantMap);
        setProductVariantMap(variantMap);

        if (Array.isArray(productIds) && productIds.length === 0) {
          console.log('ℹ️ [fetchNodeData] No raw materials found');
          sethasrawmaterial(false);
        } else {
          console.log('✅ [fetchNodeData] Node has raw materials');
          sethasrawmaterial(true);
          
          initializeNodeVariants(id, productIds, variantMap);
          
          console.log('🔄 [fetchNodeData] Starting to fetch variants and aggregates for products:', productIds);
          await Promise.all(productIds.map(async (productId) => {
            console.log(`📡 [fetchNodeData] Fetching variants for product ${productId}`);
            await fetchVariantsForRawMaterial(productId, variantMap[productId] || []);
          }));
        }

        const utilityIds = res?.input_foreign?.[0]?.value?.utility_ids || [];
        console.log('🔧 [fetchNodeData] Utility IDs:', utilityIds);
        seteditutitilty(utilityIds);
        setutitilityfromdrawer(utilityIds);

      } catch (error) {
        console.error('❌ [fetchNodeData] Error fetching node data:', error);
        enqueueSnackbar('Failed to fetch node data', { variant: 'error' });
        setFetchedNodeData(null);
        seteditutitilty([]);
        setProductVariantMap({});
        setVariantAggregates({});
        setVariantInventory({});
        setSelectedInventoryItems({});
        setTotalVariantQuantities({});
      } finally {
        setFetchingNodeData(false);
        console.log('🏁 [fetchNodeData] Finished fetching node data');
      }
    };
    
    fetchNodeData();
  }, [selectedNode, enqueueSnackbar, seteditoutputids, setutitilityfromdrawer]);

  const selectedUtilities = useMemo(() => {
    if (!editutitilty || !Array.isArray(editutitilty) || !utilityOptions) {
      return [];
    }
    return utilityOptions.filter(option =>
      editutitilty.includes(Number(option.id))
    );
  }, [editutitilty, utilityOptions]);

  useEffect(() => {
    console.log('🎯 [useEffect] Updating selectedVariants based on nodeVariants');
    if (currentNodeId && nodeVariants[currentNodeId]) {
      console.log('🎯 [useEffect] Setting selectedVariants:', nodeVariants[currentNodeId]);
      setSelectedVariants(nodeVariants[currentNodeId]);
    } else {
      console.log('🎯 [useEffect] No nodeVariants found for currentNodeId, setting empty');
      setSelectedVariants({});
    }
  }, [currentNodeId, nodeVariants]);

  const initializeNodeVariants = (nodeId, productIds, variantMap) => {
    console.log('🏗️ [initializeNodeVariants] Starting for node:', nodeId);
    console.log('🏗️ [initializeNodeVariants] Product IDs:', productIds);
    console.log('🏗️ [initializeNodeVariants] Variant Map:', variantMap);

    let initialVariants = {};
    let initialQuantities = {};
    let initialTotalQuantities = {};
    let initialSelectedInventory = {};

    productIds.forEach(productId => {
      initialVariants[productId] = [];
      initialQuantities[productId] = {};
      initialTotalQuantities[productId] = {};
      initialSelectedInventory[productId] = {};
    });

    console.log('🏗️ [initializeNodeVariants] Initial variants:', initialVariants);
    console.log('🏗️ [initializeNodeVariants] Initial quantities:', initialQuantities);
    console.log('🏗️ [initializeNodeVariants] Initial total quantities:', initialTotalQuantities);
    console.log('🏗️ [initializeNodeVariants] Initial selected inventory:', initialSelectedInventory);

    setNodeVariants(prev => {
      const newState = {
        ...prev,
        [nodeId]: initialVariants
      };
      console.log('🏗️ [initializeNodeVariants] Setting nodeVariants to:', newState);
      return newState;
    });
    
    setSelectedVariants(initialVariants);
    
    setVariantQuantities(prev => {
      const newState = {
        ...prev,
        [nodeId]: initialQuantities
      };
      console.log('🏗️ [initializeNodeVariants] Setting variantQuantities to:', newState);
      return newState;
    });

    setTotalVariantQuantities(prev => {
      const newState = {
        ...prev,
        [nodeId]: initialTotalQuantities
      };
      console.log('🏗️ [initializeNodeVariants] Setting totalVariantQuantities to:', newState);
      return newState;
    });

    setSelectedInventoryItems(prev => {
      const newState = {
        ...prev,
        [nodeId]: initialSelectedInventory
      };
      console.log('🏗️ [initializeNodeVariants] Setting selectedInventoryItems to:', newState);
      return newState;
    });
    
    console.log('✅ [initializeNodeVariants] Finished initialization');
  };

  const fetchVariantsForRawMaterial = async (rawMaterialId, variantIdsForProduct) => {
    if (!rawMaterialId) {
      console.log('❌ [fetchVariantsForRawMaterial] No rawMaterialId provided');
      return;
    }

    console.log(`📡 [fetchVariantsForRawMaterial] Starting for product ${rawMaterialId}`);
    console.log(`📡 [fetchVariantsForRawMaterial] Variant IDs for this product:`, variantIdsForProduct);

    setLoadingVariants(prev => ({ ...prev, [rawMaterialId]: true }));

    try {
      const res = await fetcher([`/new/workflow-app/products/variants/list/${rawMaterialId}/`]);
      const variants = res.results || res;
      console.log(`✅ [fetchVariantsForRawMaterial] All variants for product ${rawMaterialId}:`, variants);

      const filteredVariants = variants.filter(variant => 
        variantIdsForProduct.includes(variant.id)
      );
      
      console.log(`✅ [fetchVariantsForRawMaterial] Filtered variants for product ${rawMaterialId}:`, filteredVariants);

      setVariantOptions(prev => {
        const newState = {
          ...prev,
          [rawMaterialId]: filteredVariants
        };
        console.log(`✅ [fetchVariantsForRawMaterial] Setting variantOptions for ${rawMaterialId}:`, newState);
        return newState;
      });

      const aggregatePromises = filteredVariants.map(async (variant) => {
        try {
          const aggregateRes = await fetcher([`/new/workflow-app/product/variant/aggregate/list/${variant.id}/`]);
          setaggregableValues(aggregateRes);
          console.log(`✅ [fetchVariantsForRawMaterial] Aggregate data for variant ${variant.id}:`, aggregateRes);
          return { variantId: variant.id, aggregate: aggregateRes.aggregate_values || {} };
        } catch (error) {
          console.error(`❌ [fetchVariantsForRawMaterial] Error fetching aggregate for variant ${variant.id}:`, error);
          return { variantId: variant.id, aggregate: {} };
        }
      });

      const inventoryPromises = filteredVariants.map(async (variant) => {
        try {
          const inventoryRes = await fetcher([`/new/workflow-app/product/variant/inventory/list/${variant.id}/`]);
          console.log(`✅ [fetchVariantsForRawMaterial] Inventory data for variant ${variant.id}:`, inventoryRes);
          return { variantId: variant.id, inventory: inventoryRes || [] };
        } catch (error) {
          console.error(`❌ [fetchVariantsForRawMaterial] Error fetching inventory for variant ${variant.id}:`, error);
          return { variantId: variant.id, inventory: [] };
        }
      });

      const aggregateResults = await Promise.all(aggregatePromises);
      const inventoryResults = await Promise.all(inventoryPromises);

      setVariantAggregates(prev => {
        const newState = {
          ...prev,
          [rawMaterialId]: aggregateResults.reduce((acc, { variantId, aggregate }) => ({
            ...acc,
            [variantId]: aggregate
          }), {})
        };
        console.log(`✅ [fetchVariantsForRawMaterial] Setting variantAggregates for ${rawMaterialId}:`, newState);
        return newState;
      });

      setVariantInventory(prev => {
        const newState = {
          ...prev,
          [rawMaterialId]: inventoryResults.reduce((acc, { variantId, inventory }) => ({
            ...acc,
            [variantId]: inventory
          }), {})
        };
        console.log(`✅ [fetchVariantsForRawMaterial] Setting variantInventory for ${rawMaterialId}:`, newState);
        return newState;
      });

      if (currentNodeId && filteredVariants.length > 0) {
        console.log(`✅ [fetchVariantsForRawMaterial] Updating nodeVariants for product ${rawMaterialId}`);
        
        setNodeVariants(prev => {
          const newState = {
            ...prev,
            [currentNodeId]: {
              ...prev[currentNodeId],
              [rawMaterialId]: filteredVariants
            }
          };
          console.log(`✅ [fetchVariantsForRawMaterial] Setting nodeVariants to:`, newState);
          return newState;
        });
        
        setSelectedVariants(prev => {
          const newState = {
            ...prev,
            [rawMaterialId]: filteredVariants
          };
          console.log(`✅ [fetchVariantsForRawMaterial] Setting selectedVariants to:`, newState);
          return newState;
        });

        setVariantQuantities(prev => {
          const newState = {
            ...prev,
            [currentNodeId]: {
              ...prev[currentNodeId],
              [rawMaterialId]: filteredVariants.reduce((acc, variant) => ({
                ...acc,
                [variant.id]: prev[currentNodeId]?.[rawMaterialId]?.[variant.id] || {}
              }), {})
            }
          };
          console.log(`✅ [fetchVariantsForRawMaterial] Setting variantQuantities to:`, newState);
          return newState;
        });

        setTotalVariantQuantities(prev => {
          const newState = {
            ...prev,
            [currentNodeId]: {
              ...prev[currentNodeId],
              [rawMaterialId]: filteredVariants.reduce((acc, variant) => ({
                ...acc,
                [variant.id]: ''
              }), {})
            }
          };
          console.log(`✅ [fetchVariantsForRawMaterial] Setting totalVariantQuantities to:`, newState);
          return newState;
        });

        setSelectedInventoryItems(prev => {
          const newState = {
            ...prev,
            [currentNodeId]: {
              ...prev[currentNodeId],
              [rawMaterialId]: filteredVariants.reduce((acc, variant) => ({
                ...acc,
                [variant.id]: []
              }), {})
            }
          };
          console.log(`✅ [fetchVariantsForRawMaterial] Setting selectedInventoryItems to:`, newState);
          return newState;
        });
      } else {
        console.log(`❌ [fetchVariantsForRawMaterial] No currentNodeId or no filtered variants`);
      }
    } catch (error) {
      console.error(`❌ [fetchVariantsForRawMaterial] Error for product ${rawMaterialId}:`, error);
      enqueueSnackbar(`Failed to fetch variants for raw material ${rawMaterialId}`, { variant: 'error' });
      setVariantOptions(prev => ({ ...prev, [rawMaterialId]: [] }));
      setVariantInventory(prev => ({ ...prev, [rawMaterialId]: {} }));
      setSelectedInventoryItems(prev => ({ ...prev, [rawMaterialId]: {} }));
      setTotalVariantQuantities(prev => ({ ...prev, [rawMaterialId]: {} }));
    } finally {
      setLoadingVariants(prev => ({ ...prev, [rawMaterialId]: false }));
      console.log(`🏁 [fetchVariantsForRawMaterial] Finished for product ${rawMaterialId}`);
    }
  };

  const buildInventoryPayload = () => {
    const inventoryQuantities = [];

    const nodeData = selectedInventoryItems[currentNodeId] || {};

    Object.keys(nodeData).forEach((rawMaterialId) => {
      Object.keys(nodeData[rawMaterialId]).forEach((variantId) => {
        const selectedItems = nodeData[rawMaterialId][variantId] || [];
        const quantities = variantQuantities[currentNodeId]?.[rawMaterialId]?.[variantId] || {};
        const aggregableKey = Object.keys(aggregableValues?.aggregate_values || {})[0];
        
        selectedItems.forEach((item) => {
          const inventoryId = String(item.id);   
          const qty = Number(quantities[inventoryId] || 0);

          if (qty > 0) {
            inventoryQuantities.push({
              variant: Number(variantId),   // variant id
              key: inventoryId,             // inventory id
              quantity: qty,
              aggregableValues: aggregableKey
            });
          }
        });
      });
    });

    return {
      // keep the old flat list if the backend still expects it
      inventory_ids: inventoryQuantities.map(i => i.key),
      // NEW shape you requested
      inventory_quantities: inventoryQuantities
    };
  };

  const handleUpdateNodeWithVariants = async () => {
    console.log('🚀 [handleUpdateNodeWithVariants] Building payload...');

    if (!currentNodeId || !editNodeName.trim()) {
      enqueueSnackbar('Node name is required', { variant: 'error' });
      return;
    }

    // Build inventory payload
    const inventoryPayload = buildInventoryPayload();
    console.log('📦 [Payload] inventory_ids:', inventoryPayload);

    // Update node color
    setNodeColor('#168C04');
    // setinventoryPayload(inventoryPayload)
    
    // Pass payload to parent handler
    handleUpdateNode(inventoryPayload);

    enqueueSnackbar('Job updated with inventory allocation!', { variant: 'success' });
  };

  const handleQuantityChange = (rawMaterialId, variantId, inventoryId, value) => {
    console.log(`🔢 [handleQuantityChange] Product ${rawMaterialId}, Variant ${variantId}, Inventory ${inventoryId}, Quantity:`, value);
    const inventoryItems = variantInventory[rawMaterialId]?.[variantId] || [];
    const inventoryItem = inventoryItems.find(item => item.id === inventoryId);
    const aggregateValues = inventoryItem?.aggregate_values || {};
    const unit = Object.keys(aggregateValues)[0] || 'Unit';
    const maxValue = aggregateValues[unit] || 0;
    console.log(`🔢 [handleQuantityChange] Unit: ${unit}, Max value for inventory ${inventoryId}:`, maxValue);
    if (maxValue === 0) return; // Prevent changes if maxValue is 0
    const parsedValue = value;
    setVariantQuantities(prev => {
      const newState = {
        ...prev,
        [currentNodeId]: {
          ...prev[currentNodeId],
          [rawMaterialId]: {
            ...prev[currentNodeId]?.[rawMaterialId],
            [variantId]: {
              ...prev[currentNodeId]?.[rawMaterialId]?.[variantId],
              [inventoryId]: parsedValue
            }
          }
        }
      };
      console.log(`🔢 [handleQuantityChange] Setting variantQuantities to:`, newState);
      return newState;
    });
  };

  const handleTotalQuantityChange = (rawMaterialId, variantId, value) => {
    console.log(`🔢 [handleTotalQuantityChange] Product ${rawMaterialId}, Variant ${variantId}, Total Quantity:`, value);
    const aggregate = variantAggregates[rawMaterialId]?.[variantId] || {};
    const unit = Object.keys(aggregate)[0] || 'Unit';
    const maxValue = aggregate[unit] || 0;
    console.log(`🔢 [handleTotalQuantityChange] Unit: ${unit}, Max value:`, maxValue);
    if (maxValue === 0) return; // Prevent changes if maxValue is 0
    const parsedValue = value === '' ? '' : Math.min(Math.max(Number(value), 0), maxValue);
    setTotalVariantQuantities(prev => {
      const newState = {
        ...prev,
        [currentNodeId]: {
          ...prev[currentNodeId],
          [rawMaterialId]: {
            ...prev[currentNodeId]?.[rawMaterialId],
            [variantId]: parsedValue
          }
        }
      };
      console.log(`🔢 [handleTotalQuantityChange] Setting totalVariantQuantities to:`, newState);
      return newState;
    });
    if (Number(value) > maxValue) {
      enqueueSnackbar(`Total quantity for variant ${variantId} cannot exceed ${maxValue} ${unit}`, { variant: 'warning' });
    }
    if (Number(value) < 0) {
      enqueueSnackbar(`Total quantity for variant ${variantId} cannot be negative`, { variant: 'warning' });
    }
  };

  const handleInventoryChange = (rawMaterialId, variantId, newValue) => {
    console.log(`🔄 [handleInventoryChange] Product ${rawMaterialId}, Variant ${variantId}, Selected Inventory:`, newValue);
    setSelectedInventoryItems(prev => {
      const newState = {
        ...prev,
        [currentNodeId]: {
          ...prev[currentNodeId],
          [rawMaterialId]: {
            ...prev[currentNodeId]?.[rawMaterialId],
            [variantId]: newValue || []
          }
        }
      };
      console.log(`🔄 [handleInventoryChange] Setting selectedInventoryItems to:`, newState);
      return newState;
    });

    // Update quantities for newly selected inventory items
    const newQuantities = {};
    (newValue || []).forEach(item => {
      const aggregateValues = item.aggregate_values || {};
      const unit = Object.keys(aggregateValues)[0] || 'Unit';
      const maxValue = aggregateValues[unit] || 0;
      newQuantities[item.id] = maxValue;
    });

    setVariantQuantities(prev => {
      const newState = {
        ...prev,
        [currentNodeId]: {
          ...prev[currentNodeId],
          [rawMaterialId]: {
            ...prev[currentNodeId]?.[rawMaterialId],
            [variantId]: newQuantities
          }
        }
      };
      console.log(`🔄 [handleInventoryChange] Setting variantQuantities to:`, newState);
      return newState;
    });

    // Reset total quantity when inventory items are selected
    setTotalVariantQuantities(prev => {
      const newState = {
        ...prev,
        [currentNodeId]: {
          ...prev[currentNodeId],
          [rawMaterialId]: {
            ...prev[currentNodeId]?.[rawMaterialId],
            [variantId]: ''
          }
        }
      };
      console.log(`🔄 [handleInventoryChange] Resetting totalVariantQuantities for variant ${variantId} to:`, newState);
      return newState;
    });
  };

  console.log('🎨 [RENDER] Current state:', {
    nodeVariants,
    selectedVariants,
    currentNodeId,
    variantQuantities: variantQuantities[currentNodeId],
    totalVariantQuantities: totalVariantQuantities[currentNodeId],
    variantAggregates,
    variantInventory,
    selectedInventoryItems
  });

  return (
    <>
      <Drawer 
        anchor="right" 
        open={open} 
        onClose={onClose}
        PaperProps={{
          sx: {
            width: 420,
            background: 'linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%)',
          }
        }}
      >
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Header */}
          <Box 
            sx={{ 
              p: 3, 
              background: 'linear-gradient(135deg, #168344ff 0%, #4ba259ff 100%)',
              color: 'white',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
          >
            <Typography variant="h5" fontWeight={600} gutterBottom>
              {/* FIXED: Access name from selectedNode.data.label */}
              {selectedNode?.data?.label || 'Node'}
            </Typography>
            {currentNodeId && (
              <Chip 
                label={`ID: ${currentNodeId}`} 
                size="small" 
                sx={{ 
                  bgcolor: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  fontWeight: 500
                }} 
              />
            )}
          </Box>

          {/* Content */}
          <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
            {fetchingNodeData || loadingNodeData ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                <CircularProgress size={40} />
              </Box>
            ) : fetchedNodeData ? (
              <>
                {/* Node Details Card */}
                <Card 
                  elevation={0}
                  sx={{ 
                    mb: 3, 
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    overflow: 'hidden'
                  }}
                >
                  <Box 
                    sx={{ 
                      p: 2, 
                      bgcolor: 'grey.50',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      cursor: 'pointer'
                    }}
                    onClick={() => setShowNodeDetails(!showNodeDetails)}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Iconify icon="material-symbols:info" fontSize="small" color="primary" />
                      <Typography variant="subtitle2" fontWeight={600} color="text.primary">
                        Node Details
                      </Typography>
                    </Box>
                    <IconButton size="small">
                      {showNodeDetails ? <Iconify icon="mdi:expand-less" /> : <Iconify icon="mdi:expand-more" />}
                    </IconButton>
                  </Box>
                  
                  <Collapse in={showNodeDetails}>
                    <CardContent>
                      <Stack spacing={1.5}>
                        <Box>
                          <Typography variant="caption" color="text.secondary" fontWeight={600}>
                            Type
                          </Typography>
                          <Typography variant="body2">{fetchedNodeData.type}</Typography>
                        </Box>
                        
                        <Divider />
                        
                        <Box>
                          <Typography variant="caption" color="text.secondary" fontWeight={600}>
                            Name
                          </Typography>
                          <Typography variant="body2">{fetchedNodeData.name}</Typography>
                        </Box>

                        {fetchedNodeData.input_foreign && fetchedNodeData.input_foreign.length > 0 && (
                          <>
                            <Divider />
                            
                            <Box>
                              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                                Product IDs
                              </Typography>
                              <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {(fetchedNodeData.input_foreign[0]?.value?.product_ids || []).map(id => (
                                  <Chip key={id} label={id} size="small" variant="outlined" />
                                ))}
                                {(fetchedNodeData.input_foreign[0]?.value?.product_ids || []).length === 0 && (
                                  <Typography variant="body2" color="text.secondary">None</Typography>
                                )}
                              </Box>
                            </Box>

                            {fetchedNodeData.input_foreign[0].formula && fetchedNodeData.input_foreign[0].formula.length > 0 && (
                              <>
                                <Divider />
                                <Box>
                                  <Typography variant="caption" color="text.secondary" fontWeight={600} gutterBottom>
                                    Input Formulas
                                  </Typography>
                                  <Stack spacing={0.5} sx={{ mt: 1 }}>
                                    {fetchedNodeData.input_foreign[0].formula.map((formula, index) => (
                                      <Paper key={index} variant="outlined" sx={{ p: 1, bgcolor: 'grey.50' }}>
                                        <Typography variant="caption" fontWeight={600}>
                                          {formula.name}:
                                        </Typography>
                                        <Typography variant="caption" sx={{ ml: 1, fontFamily: 'monospace' }}>
                                          {reconstructFormulaString(formula.formula)}
                                        </Typography>
                                      </Paper>
                                    ))}
                                  </Stack>
                                </Box>
                              </>
                            )}
                          </>
                        )}

                        {fetchedNodeData.output_foreign && fetchedNodeData.output_foreign.length > 0 && (
                          <>
                            <Divider />
                            <Box>
                              <Typography variant="caption" color="text.secondary" fontWeight={600} gutterBottom>
                                Output Formulas
                              </Typography>
                              <Stack spacing={0.5} sx={{ mt: 1 }}>
                                {fetchedNodeData.output_foreign.map((output, index) => (
                                  <Paper key={index} variant="outlined" sx={{ p: 1, bgcolor: 'grey.50' }}>
                                    <Typography variant="caption" fontWeight={600}>
                                      {output.name}:
                                    </Typography>
                                    <Typography variant="caption" sx={{ ml: 1, fontFamily: 'monospace' }}>
                                      {reconstructFormulaString(output.formula)}
                                    </Typography>
                                  </Paper>
                                ))}
                              </Stack>
                            </Box>
                          </>
                        )}

                        {fetchedNodeData.cost_foreign && fetchedNodeData.cost_foreign.length > 0 && (
                          <>
                            <Divider />
                            <Box>
                              <Typography variant="caption" color="text.secondary" fontWeight={600} gutterBottom>
                                Costs
                              </Typography>
                              <Stack spacing={0.5} sx={{ mt: 1 }}>
                                {fetchedNodeData.cost_foreign.map((cost, index) => (
                                  <Paper key={index} variant="outlined" sx={{ p: 1, bgcolor: 'grey.50' }}>
                                    <Typography variant="caption">
                                      <strong>{cost.name}:</strong> {cost.value.amount} {cost.value.unit}
                                    </Typography>
                                  </Paper>
                                ))}
                              </Stack>
                            </Box>
                          </>
                        )}
                      </Stack>
                    </CardContent>
                  </Collapse>
                </Card>

                {/* Node Name Field */}
                <TextField
                  label="Node Name"
                  value={editNodeName}
                  onChange={(e) => setEditNodeName(e.target.value)}
                  fullWidth
                  disabled
                  sx={{ 
                    mb: 3,
                    '& .MuiOutlinedInput-root': {
                      bgcolor: 'white',
                      borderRadius: 2
                    }
                  }}
                />

                {/* Variants Section */}
                {Object.keys(selectedVariants).length > 0 && (
                  <Card 
                    elevation={0}
                    sx={{ 
                      mb: 3,
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 2
                    }}
                  >
                    <Box sx={{ p: 2, bgcolor: 'primary.50', borderBottom: '1px solid', borderColor: 'divider' }}>
                      <Typography variant="subtitle2" fontWeight={600} color="primary.main">
                        Selected Variants & Quantities
                      </Typography>
                    </Box>
                    <CardContent>
                      <Stack spacing={3}>
                        {Object.entries(selectedVariants).map(([rawMaterialId, variants]) => (
                          <Box key={rawMaterialId}>
                            <Box 
                              sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1,
                                mb: 2,
                                pb: 1,
                                borderBottom: '1px dashed',
                                borderColor: 'divider'
                              }}
                            >
                              <Chip 
                                label={`Material ID: ${rawMaterialId}`}
                                size="small"
                                color="primary"
                                variant="outlined"
                              />
                            </Box>
                            
                            {variants && variants.length > 0 ? (
                              <Stack spacing={2}>
                                {variants.map((variant, index) => {
                                  const aggregate = variantAggregates[rawMaterialId]?.[variant.id] || {};
                                  const unit = Object.keys(aggregate)[0] || 'Unit';
                                  const maxValue = aggregate[unit] || 0;
                                  const selectedItems = selectedInventoryItems[currentNodeId]?.[rawMaterialId]?.[variant.id] || [];
                                  const isDisabled = maxValue === 0 || selectedItems.length > 0;
                                  const inventoryItems = variantInventory[rawMaterialId]?.[variant.id] || [];
                                  
                                  return (
                                    <Paper 
                                      key={index} 
                                      elevation={0}
                                      sx={{ 
                                        p: 2, 
                                        bgcolor: 'grey.50',
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'divider'
                                      }}
                                    >
                                      <Typography 
                                        variant="body2" 
                                        fontWeight={600}
                                        sx={{ mb: 1.5 }}
                                      >
                                        {typeof variant === 'object' ? variant.name : `Variant ID: ${variant}`}
                                      </Typography>
                                      <TextField
                                        label={`Total Quantity (${unit})`}
                                        type="number"
                                        value={
                                          isDisabled
                                            ? Object.values(variantQuantities[currentNodeId]?.[rawMaterialId]?.[variant.id] || {}).reduce((sum, val) => sum + (Number(val) || 0), 0)
                                            : totalVariantQuantities[currentNodeId]?.[rawMaterialId]?.[variant.id] || ''
                                        }
                                        onChange={(e) => handleTotalQuantityChange(rawMaterialId, variant.id, e.target.value)}
                                        disabled={isDisabled}
                                        fullWidth
                                        size="small"
                                        inputProps={{ 
                                          min: 0,
                                          // max: maxValue,
                                          step: 0.1
                                        }}
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            bgcolor: 'white',
                                            borderRadius: 1.5
                                          },
                                          mb: 2
                                        }}
                                      />
                                      <Autocomplete
                                        multiple
                                        options={inventoryItems}
                                        getOptionLabel={(option) => {
                                          const attributes = option.attributes || {};
                                          const attributeString = Object.entries(attributes)
                                            .map(([key, value]) => `${key}: ${value}`)
                                            .join(' | ');
                                          return `ID: ${option.id} | ${attributeString}`;
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Select Inventory Items"
                                            size="small"
                                            sx={{
                                              '& .MuiOutlinedInput-root': {
                                                bgcolor: 'white',
                                                borderRadius: 1.5
                                              }
                                            }}
                                          />
                                        )}
                                        onChange={(event, newValue) => handleInventoryChange(rawMaterialId, variant.id, newValue)}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        value={selectedItems}
                                        fullWidth
                                        sx={{ mb: 2 }}
                                      />
                                      {selectedItems.map((item, idx) => {
                                        const aggregateValues = item.aggregate_values || {};
                                        const itemUnit = Object.keys(aggregateValues)[0] || 'Unit';
                                        const itemMaxValue = aggregateValues[itemUnit] || 0;
                                        return (
                                          <TextField
                                            key={item.id}
                                            label={`Quantity for Inventory ${item.id} (${itemUnit})`}
                                            type="number"
                                            value={variantQuantities[currentNodeId]?.[rawMaterialId]?.[variant.id]?.[item.id] || ''}
                                            onChange={(e) => handleQuantityChange(rawMaterialId, variant.id, item.id, e.target.value)}
                                            fullWidth
                                            size="small"
                                            inputProps={{
                                              min: 0,
                                              // max: itemMaxValue,
                                              step: 0.1
                                            }}
                                            sx={{
                                              '& .MuiOutlinedInput-root': {
                                                bgcolor: 'white',
                                                borderRadius: 1.5
                                              },
                                              mb: 1
                                            }}
                                          />
                                        );
                                      })}
                                    </Paper>
                                  );
                                })}
                              </Stack>
                            ) : (
                              <Box 
                                sx={{ 
                                  p: 2, 
                                  textAlign: 'center',
                                  bgcolor: 'grey.50',
                                  borderRadius: 2,
                                  border: '1px dashed',
                                  borderColor: 'divider'
                                }}
                              >
                                <Typography variant="body2" color="text.secondary">
                                  No variants selected
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        ))}
                      </Stack>
                    </CardContent>
                  </Card>
                )}
              </>
            ) : (
              <Box 
                sx={{ 
                  p: 3, 
                  textAlign: 'center',
                  bgcolor: 'grey.50',
                  borderRadius: 2,
                  border: '1px dashed',
                  borderColor: 'divider'
                }}
              >
                <Iconify icon="material-symbols:info" sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                <Typography variant="body2" color="text.secondary">
                  No node data available
                </Typography>
              </Box>
            )}
          </Box>

          {/* Action Buttons Footer */}
          <Box 
            sx={{ 
              p: 3, 
              borderTop: '1px solid',
              borderColor: 'divider',
              bgcolor: 'white',
              boxShadow: '0 -4px 6px rgba(0,0,0,0.05)'
            }}
          >
            <Stack spacing={1.5}>
              <Button
                variant="contained"
                size="large"
                onClick={handleUpdateNodeWithVariants}
                disabled={!editNodeName.trim()}
                startIcon={isEditing ? <Iconify icon="material-symbols:edit" /> : <Iconify icon="mdi:play" />}
                sx={{ 
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  py: 1.5,
                  background: 'linear-gradient(135deg, #057613ff 0%, #4ba24cff 100%)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #2ec742ff 0%, #04632eff 100%)',
                  },
                  boxShadow: '0 4px 12px rgba(102, 234, 153, 0.4)'
                }}
              >
                {isEditing ? 'Update Job' : 'Start Job'}
              </Button>
            </Stack>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default NodePropertiesDrawer3rdStep;